if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {

      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;
      this.autoScrollInterval = null;
      this.autoScrollDelay = 7000; // 5 seconds between slides
      
      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', ()=>{
          this.changeSlide('next', true);
        });
      }
      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', ()=>{
          this.changeSlide('prev', true);
        });
      }

      // Start auto-scroll if there are multiple slides
      if ( this.length > 1 ) {
        this.startAutoScroll();
      }

      // Pause on hover
      this.addEventListener('mouseenter', () => {
        this.stopAutoScroll();
      });

      this.addEventListener('mouseleave', () => {
        if ( this.length > 1 ) {
          this.startAutoScroll();
        }
      });
      
    }

    startAutoScroll() {
      this.stopAutoScroll(); // Clear any existing interval
      this.autoScrollInterval = setInterval(() => {
        // Move to next slide, or loop back to start
        if ( this.index < this.length - 1 ) {
          this.changeSlide('next');
        } else {
          this.index = -1; // Will become 0 in changeSlide
          this.changeSlide('next');
        }
      }, this.autoScrollDelay);
    }

    stopAutoScroll() {
      if ( this.autoScrollInterval ) {
        clearInterval(this.autoScrollInterval);
        this.autoScrollInterval = null;
      }
    }

    changeSlide(direction, userInitiated = false) {

      // If user manually clicked, restart the auto-scroll timer
      if ( userInitiated && this.length > 1 ) {
        this.startAutoScroll();
      }

      this.nextButton.classList.remove('announcement-bar__content-nav--disabled')
      this.prevButton.classList.remove('announcement-bar__content-nav--disabled')

      if ( direction == 'next' ) {
        this.index++;
      } else if ( direction == 'prev' ) {
        this.index--;
      }

      if ( this.index == this.length - 1 ) {
        this.nextButton.classList.add('announcement-bar__content-nav--disabled')
      } else if ( this.index == 0 ) {
        this.prevButton.classList.add('announcement-bar__content-nav--disabled')
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });

    }

  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
	}

}